export const apiPath = '/v1/documents';
const actionType = 'DOCUMENTS_V2';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
